import React from 'react' // eslint-disable-line no-unused-vars
import Select from '../../forms/Select'

const PatientDeliveryMethod = ({fields, validate, deliveryMethods, updateValidationField }) => {
    const deliveryMethodOptions = deliveryMethods.map(method =>
        ({
            value: method.delivery,
            label: method.translation || method.delivery
        }))

    return (
        <div className='patient-delivery-method'>
            <Select
                searchable
                clearable={false}
                placeholder={fields.deliveryMethod.placeholder}
                disabled={fields.deliveryMethod.disabled}
                options={deliveryMethodOptions}
                field={fields.deliveryMethod}
                validate={e => validate(e, fields.deliveryMethod)}
                onChange={updateValidationField}
            />
        </div>
    )
}

export default PatientDeliveryMethod


// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/PatientDeliveryMethod.js